<template>
  <v-dialog
    v-model="dialogVisible"
    fullscreen
    hide-overlay
    :retain-focus="false"
    persistent
    transition="dialog-bottom-transition"
  >
    <!-- Botón de Ver más -->
    <template v-slot:activator="{ on, attrs }">
      <v-btn v-bind="attrs" v-on="on" x-small rounded color="primary" dark>
        {{ $t('button.seeMore') }}
      </v-btn>
    </template>
    <v-card>
      <v-toolbar dark color="secondary">
        <v-btn icon dark class="btn btn-primary" @click="closeDialog">
          <v-icon>mdi-close</v-icon>
        </v-btn>

        <v-toolbar-title>{{ formData.reportName }}</v-toolbar-title>

        <template v-slot:extension>
          <v-tabs v-model="tab" align-with-title>
            <v-tabs-slider color="accent"></v-tabs-slider>
            <v-tab v-for="(item, index) in items" :key="index">
              {{ item }}
            </v-tab>
          </v-tabs>
        </template>
      </v-toolbar>

      <v-tabs-items v-model="tab">
        <v-tab-item v-for="(item, index) in items" :key="index">
          <component :is="getComponent(item)" :report="formData" />
        </v-tab-item>
      </v-tabs-items>
    </v-card>
  </v-dialog>
</template>

<script>
import historicMonetization from "@/views/reports/pages/detail_report/components/form_historic_monetization_component.vue";
import confirmMonetization from "@/views/reports/pages/detail_report/components/form_confirm_monetization_component.vue";
import historicAssignment from "@/views/reports/pages/detail_report/components/form_historic_assignment_component.vue";
import formDetailReport from "@/views/reports/pages/detail_report/components/form_confirm_monetization_component.vue";
import startMonetization from "@/views/reports/pages/detail_report/components/form_start_monetization_component.vue";
import monthlyChartComponent from "@/views/reports/pages/detail_report/components/monthly_chart_component.vue";
import weeklyChartComponent from "@/views/reports/pages/detail_report/components/weekly_chart_component.vue";
import annualChartComponent from "@/views/reports/pages/detail_report/components/annual_chart_component.vue";
import formStarsBalanceComponent from "@/views/reports/pages/detail_report/components/form_stars_balance_component.vue";
import formAffiliatesPeriodComponent from "@/views/reports/pages/detail_report/components/form_affiliates_period_component.vue";
import formAffiliatesBotStarsComponent from "@/views/reports/pages/detail_report/components/form_affiliates_bot_stars_component.vue";
import formStarTaxReportComponent from "@/views/reports/pages/detail_report/components/form_star_tax_report_component.vue";
import i18n from '@/plugins/i18n';

export default {
  name: "detailReport",
  components: {
    monthlyChartComponent,
    weeklyChartComponent,
    annualChartComponent,
    historicMonetization,
    confirmMonetization,
    historicAssignment,
    startMonetization,
    formDetailReport,
    formStarsBalanceComponent,
    formAffiliatesPeriodComponent,
    formAffiliatesBotStarsComponent,
    formStarTaxReportComponent,
  },
  props: {
    reportProps: {
      required: true,
    },
  },
  data() {
    return {
      dialogVisible: false,
      tab: null,
      items: [],
      formData: {},
    };
  },

  mounted() {
    if (this.reportProps) {
      this.formData = { ...this.reportProps };
      this.items = this.getItems(this.reportProps.reportId);
    }
  },

  methods: {

    closeDialog() {
      this.dialogVisible = false;
      window.location.reload();
    },

    getItems(condition) {
      switch (condition) {
        case 1:
        return [this.$t('report.label.startMonetization'), this.$t('report.label.confirmMonetization')];
        case 2:
          return ["Análisis Avanzado"];
        case 3:
          return [this.$t('report.label.historicMonetization')];
        case 4:
          return [this.$t('report.label.weeklyChart'), this.$t('report.label.monthlyChart'), this.$t('report.label.annualChart')];
        case 5:
          return [this.$t('label.option.assignment')];
        case 6:
          return [this.$t('report.label.starsBalance.title')];
        case 7:
          return [this.$t('report.label.affiliatesPeriod.title')];
        case 8:
          return [this.$t('report.label.affiliatesBotStars.title')];
        case 9:
          return [this.$t('report.label.starTax.title')];
        default:
          return ["Sin Datos"];
      }
    },

    getComponent(tabName) {
      const componentsMap = {
        [i18n.t('report.label.historicMonetization')]: "historicMonetization",
        [i18n.t('report.label.confirmMonetization')]: "confirmMonetization",
        [i18n.t('label.option.assignment')]: "historicAssignment",
        [i18n.t('report.label.startMonetization')]: "startMonetization",
        [i18n.t('report.label.monthlyChart')]: "monthlyChartComponent",
        [i18n.t('report.label.weeklyChart')]: "weeklyChartComponent",
        [i18n.t('report.label.annualChart')]: "annualChartComponent",
        [i18n.t('label.tab')]: "formDetailReport",
        [i18n.t('report.label.starsBalance.title')]: "formStarsBalanceComponent",
        [i18n.t('report.label.affiliatesPeriod.title')]: "formAffiliatesPeriodComponent",
        [i18n.t('report.label.affiliatesBotStars.title')]: "formAffiliatesBotStarsComponent",
        [i18n.t('report.label.starTax.title')]: "formStarTaxReportComponent",
        "Informe Detallado": "formDetailReport",
        "Análisis Avanzado": "advancedAnalysis",
        [i18n.t('chart.label.notData')]: "formDetailReport",
      };
      return componentsMap[tabName] || "formDetailReport";
    },

  },
  
};

</script>
